module.exports = __webpack_public_path__ + "img/1f.95cb9227.svg";